import _ from "underscore"
window._ = _
import "jquery/src/jquery"

/**
 * Marmoset Music global namespace
 * @type {Object}
 */

var mm = (window.mm = {})

mm.hasHistory = "pushState" in window.history ? true : false

mm.facade = _.extend({}, Backbone.Events)
mm.drawerProxy = _.extend({}, Backbone.Events)
mm.drawerProxy.on("all", function (evt, args) {
  var device = $(document.body).attr("data-device")
  mm.drawer.trigger(evt, args)
})
mm.playerProxy = _.extend({}, Backbone.Events)
mm.playerProxy.on("all", function (evt, args) {
  var device = window.matchMedia("(pointer: coarse)").matches || mm.isMobile ? "mobile" : "desktop"
  mm[device + "Player"].trigger(evt, args)
})

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// MIT license
;(function () {
  var lastTime = 0
  var vendors = ["ms", "moz", "webkit", "o"]
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"]
    window.cancelAnimationFrame =
      window[vendors[x] + "CancelAnimationFrame"] ||
      window[vendors[x] + "CancelRequestAnimationFrame"]
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime()
      var timeToCall = Math.max(0, 16 - (currTime - lastTime))
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    }
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id)
    }
  }
})()

/**
 * Page visibility polyfill
 */
;(function () {
  var _hiddenPrefix = "hidden"
  // Listen for document hidden event
  if (_hiddenPrefix in document) {
    document.addEventListener("visibilitychange", onVisibility)
  } else if ((_hiddenPrefix = "mozHidden") in document) {
    document.addEventListener("mozvisibilitychange", onVisibility)
  } else if ((_hiddenPrefix = "webkitHidden") in document) {
    document.addEventListener("webkitvisibilitychange", onVisibility)
  } else if ((_hiddenPrefix = "msHidden") in document) {
    document.addEventListener("msvisibilitychange", onVisibility)
    // IE 9 and lower:
  } else if ("onfocusin" in document) {
    document.onfocusin = document.onfocusout = onVisibility
    // All others:
  } else {
    window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onVisibility
  }

  // Song versions page visibility
  // I.e. when a different tab is sactive
  function onVisibility(e) {
    e = e || window.event
    var stateMap = {
        focus: "visible",
        focusin: "visible",
        pageshow: "visible",
        blur: "hidden",
        focusout: "hidden",
        pagehide: "hidden",
      },
      state = stateMap[e.type]

    state = typeof state !== "undefined" ? state : this[_hiddenPrefix] ? "hidden" : "visible"
    if (state === "hidden") {
      mm.facade.trigger("page:hidden")
    } else if (state === "visible") {
      mm.facade.trigger("page:visible")
    }
  }
})()

// from http://stackoverflow.com/a/5047712
String.prototype.width = function (font) {
  var f = font || "12px arial",
    o = $("<div>" + this + "</div>")
      .css({
        position: "absolute",
        float: "left",
        "white-space": "nowrap",
        visibility: "hidden",
        font: f,
      })
      .appendTo($("body")),
    w = o.width()

  o.remove()

  return w
}

/**
 * Touch classes
 */
;(function ($) {
  if (mm.isMobile) {
    $("body").addClass("touch")
    $("[data-touch]").addClass("touch")
  }
})(jQuery)

/**
 * var email = "test@email.com";
 * email.validEmail();
 * @return {boolean} whether or not email provided is valid
 */
String.prototype.validEmail = function () {
  var email = this.toString()
  var re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * detects width of the os scrollbar
 * http://davidwalsh.name/detect-scrollbar-width
 * @return {[type]} [description]
 */
window.scrollBarWidth = function () {
  // Create the measurement node
  var scrollDiv = document.createElement("div")
  scrollDiv.className = "scrollbar-measure"
  document.body.appendChild(scrollDiv)

  // Get the scrollbar width
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth

  // Delete the DIV
  document.body.removeChild(scrollDiv)

  return scrollbarWidth
}

/**
 * scrollbar detect on div
 * http://stackoverflow.com/questions/4814398/how-can-i-check-if-a-scrollbar-is-visible
 * @param  {[type]} $ [description]
 * @return {[type]}   [description]
 */
;(function ($) {
  $.fn.hasScrollBar = function () {
    return this.get(0).scrollHeight > this.height()
  }
})(jQuery)

/**
 * Auto-hide scrollbars on ios
 */
;(function () {
  function hideBar(force) {
    var minHeight = window.innerHeight + 60
    // Only hide the address bar if forcing it to hide or if the height of the body is
    // less than the minimum height needed to hide the address bar.
    if (force === true || parseInt(document.body.style.height, 10) < minHeight) {
      document.body.style.height = minHeight + "px"
    }
    setTimeout(function () {
      window.scrollTo(0, 1)
    }, 0)
  }

  var isIOS = navigator.userAgent.match(/iPhone|iPod/i)
  if (isIOS) {
    // Hide the address bar on load
    hideBar(true)
    window.addEventListener("orientationchange", hideBar)
  }
})()

/**
 * firefox detection
 */
window.isFF = navigator.userAgent.toLowerCase().indexOf("firefox") > -1
